export const collectMapViewBounds = ({ ne, nw, se, sw }) => {
  return [ne, nw, sw, se, ne].map(bound => [bound.lat, bound.lng])
}
